import { createAction, props } from '@ngrx/store';
import { Company } from '../../../core/domain/company/company';

export const minimizeSideMenu = createAction('[minimize] Side Menu');
export const maximizeSideMenu = createAction('[maximize] Side Menu');

// Generic modal monitor for backdrop - needed some animation
export const openAModal = createAction('[open] Modal Backdrop');
export const closeAModal = createAction('[close] Modal Backdrop');

export const setCompanies = createAction(
  '[set] Companies',
  props<{ companies: Company[] }>()
);
export const chooseCompany = createAction(
  '[choose] Company',
  props<{ companyId: string | null }>()
);

export const openSelectCompanyModal = createAction(
  '[open] Select Company Modal'
);
export const closeSelectCompanyModal = createAction(
  '[close] Select Company Modal'
);
